module.exports = __webpack_public_path__ + "svg_80x80/vue.f70ced.svg";